<template>
  <div :id="id"></div>
</template>
<script>
export default {
  name: 'DfpSlot',
  props: { size: Array, path: String, id: String },
  beforeCreate() {
    window.googletag.cmd.push(() => {
      window.googletag.destroySlots();
    });
  },
  mounted() {
    const { path, size, id } = this;
    window.googletag.cmd.push(() => {
      window.googletag
        .defineSlot(path, size, id)
        .addService(window.googletag.pubads())
        .setTargeting('Page_Url', 'especiais.estadao.com.br/jbs/70anos/')
        .setTargeting('Key_Value', 'jbs70anos')
        .setTargeting('tag', 'jbs70anos');
      window.googletag.pubads().enableSingleRequest();
      window.googletag.enableServices();
      window.googletag.display(id);
    });
  },
};
</script>
